import { yupResolver } from '@hookform/resolvers/yup';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
	Typography,
} from '@mui/material';
import {
	DefaultValues,
	FormProvider,
	SubmitHandler,
	useForm,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import Close from '@mui/icons-material/Close';
import {
	useGetClockListQuery,
	useSetDefaultClockMutation,
} from '@/api/app-setting/clockApiSlice';
import CloseIcon from '@mui/icons-material/Close';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { ClockRequest } from '@/api/DTO/app-setting/clock.interface';
import AppDropDownMenu from '@/common/components/form-inputs/AppDropDownMenu';
import { FormType } from '@/api/enum/formType.enum';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { Form } from 'react-router-dom';
import AppTextField from '@/common/components/form-inputs/AppTextField';
import {
	useCreateNoticeMutation,
	useUpdateNoticeMutation,
} from '@/api/app-setting/noticeApiSlice';
import {
	NoticePageDTO,
	NoticeRequest,
} from '@/api/DTO/app-setting/notice.interface';

interface Props {
	reSetOpen: boolean;
	setReSetOpen: any;
	type: FormType;
	setType: Dispatch<SetStateAction<FormType>>;
	row?: NoticePageDTO;
}

export default function NoticeDialog(props: Props) {
	const { reSetOpen, setReSetOpen, type, setType, row } = props;
	const { t } = useTranslation();
	const [createNotice] = useCreateNoticeMutation();
	const [updateNotice] = useUpdateNoticeMutation();
	const defaultValues: DefaultValues<NoticeRequest> = {};
	useEffect(() => {
		if (row) {
			methods.reset({
				contentZh: row?.contentZh ?? '',
				contentEn: row?.contentEn ?? '',
			});
		}
	}, [row]);
	const formSchema = Yup.object().shape({
		contentZh: Yup.string().required(t('errorMessage.required')),
	});

	const methods = useForm<NoticeRequest>({
		defaultValues,
		resolver: yupResolver(formSchema),
	});

	const handleClose = () => {
		methods.reset();
		setReSetOpen(false);
		setType(FormType.edit);
	};

	useEffect(() => {
		console.log(reSetOpen);
		if (!reSetOpen) {
			methods.reset({
				contentZh: '',
				contentEn: '',
			});
		}
	}, [reSetOpen]);

	const onSubmit: SubmitHandler<NoticeRequest> = async (data) => {
		const response =
			type == FormType.create
				? await createNotice(data)
				: await updateNotice({ ...data, id: row?.id });

		if ('data' in response) {
			enqueueSnackbar(
				type == FormType.create
					? t('snackbar.createNoticeSuccess')
					: t('snackbar.editNoticeSuccess'),
				{
					variant: 'success',
					anchorOrigin: { horizontal: 'center', vertical: 'top' },
					autoHideDuration: 3000,
					action: (key) => {
						return <CloseIcon onClick={() => closeSnackbar(key)} />;
					},
				}
			);
			handleClose();
		}
	};

	return (
		<>
			<Dialog
				open={reSetOpen}
				onClose={() => handleClose()}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				maxWidth='xs'
				fullWidth
			>
				<DialogTitle variant='h5'>
					{type == FormType.create
						? t('notice.createTemplate')
						: t('notice.editTemplate')}
				</DialogTitle>
				<IconButton
					aria-label='close'
					onClick={() => handleClose()}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<Close />
				</IconButton>
				<DialogContent>
					<FormProvider {...methods}>
						<form onSubmit={methods.handleSubmit(onSubmit)}>
							<Grid container spacing={2} marginTop={0}>
								<Grid item xs={12}>
									<AppTextField
										control={methods.control}
										name='contentZh'
										label={t('notice.noticeTemplateZh')}
									/>
								</Grid>
								<Grid item xs={12}>
									<AppTextField
										control={methods.control}
										name='contentEn'
										label={t('notice.noticeTemplateEn_')}
									/>
								</Grid>
							</Grid>
						</form>
					</FormProvider>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => handleClose()}>{t('button.cancel')}</Button>
					<Button
						type='submit'
						variant='contained'
						onClick={methods.handleSubmit(onSubmit)}
					>
						{t('button.isConfirm')}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}
